// =========================================================
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import CategoryIcon from "@mui/icons-material/Category";
import ClassIcon from "@mui/icons-material/Class";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import DescriptionIcon from "@mui/icons-material/Description";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import HdrAutoIcon from "@mui/icons-material/HdrAuto";
import HubIcon from "@mui/icons-material/Hub";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MenuIcon from "@mui/icons-material/Menu";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import PermDataSettingIcon from "@mui/icons-material/PermDataSetting";
import Person2Icon from "@mui/icons-material/Person2";
import PsychologyIcon from "@mui/icons-material/Psychology";
import Shop2Icon from "@mui/icons-material/Shop2";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import SpeakerGroupIcon from "@mui/icons-material/SpeakerGroup";
import WidgetsIcon from "@mui/icons-material/Widgets";
import Icon from "@mui/material/Icon";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import FunctionsIcon from "@mui/icons-material/Functions";
import PersonAddDisabledIcon from "@mui/icons-material/PersonAddDisabled";
import RuleFolderIcon from "@mui/icons-material/RuleFolder";
import TaskIcon from "@mui/icons-material/Task";
//components
import About from "layouts/about/about";
import GroupMenus from "layouts/admin/groupmenu";
import Menus from "layouts/admin/menu";
import Roles from "layouts/admin/roles";
import Users from "layouts/admin/users";
import Users2 from "layouts/admin/users2";
import ConfirmPassword from "layouts/authentication/confirm-password";
import Cover from "layouts/authentication/reset-password/cover";
import SignIn from "layouts/authentication/sign-in";
import Dashboard from "layouts/dashboard";
import Home from "layouts/home";
import News from "layouts/news/news";
import SignOwner from "layouts/signOwner/signOwner";
//
import {
  DataSaverOn,
  Extension,
  Flaky,
  ImportExport,
  ShareRounded,
  Star,
  TaskAlt,
} from "@mui/icons-material";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import DetailNews from "components/NewsList/detailNews";
import ChuTheOCOP from "layouts/chuTheOCOP/chuTheOCOP";
import DangKySanPham from "layouts/dangKySanPham/dangKySanPham";
import BoTieuChi from "layouts/danhmuc/botieuchi";
import DonVi from "layouts/danhmuc/donvihanhchinh";
import LoaiHinh from "layouts/danhmuc/loaihinh";
import NganhNghe from "layouts/danhmuc/nganhnghe";
import NhomBoTieuChi from "layouts/danhmuc/nhombotieuchi";
import NhomCha from "layouts/danhmuc/nhomcha";
import NhomNganhNghe from "layouts/danhmuc/nhomnganhnghe";
import NhomSanPham from "layouts/danhmuc/nhomsanpham";
import HoSoDangKy from "layouts/hoSoDangKy/hoSoDangKy";
import DetailChamDiem from "layouts/phieuChamDiem/detailChamDiem";
import FormChamDiem from "layouts/phieuChamDiem/formChamDiem";
import PhieuChamDiem from "layouts/phieuChamDiem/phieuChamDiem";
import QuanLyHoiDong from "layouts/phieuChamDiem/quanlyHoidong";
import DonViHoiDong from "layouts/quanlyhoidong/donVi";
import HoiDong from "layouts/quanlyhoidong/quanLyHoiDong";
import ThanhVien from "layouts/quanlyhoidong/thanhVienHoiDong";
import SanPhamOCOP from "layouts/sanpham";
import TinTuc from "layouts/tinTuc/tinTuc";
import Vanban from "layouts/vanban";
import { PermissionMenuKey } from "./utils/constants";
import ThongKeSanPham from "layouts/baocaothongke/ThongKeSanPham/thongKeSanPham";
import HoiDongOCOPCapTinh from "layouts/OCOPCapTinh/ocopcaptinh";
import DetailChamDiemCapTinh from "layouts/OCOPCapTinh/detailChamDiem";
import FormChamDiemCapTinh from "layouts/OCOPCapTinh/formChamDiem";
import TongHopSanPhamOCOP from "layouts/baocaothongke/TongHopSanPham/tongHopSanPham";
import HoSoDangKySanPham from "layouts/OCOPCapTinh/hosoDangky";
import GioiThieu from "layouts/about/giothieu";
import ThongKeChuThe from "layouts/baocaothongke/ThongKeChuThe/thongKeChuThe";
import Hang from "layouts/danhmuc/hang";
import QuanLyGiayPhep from "layouts/quanlygiayphep/QuanLyGiayPhep";
import LoaiVanBan from "layouts/danhmuc/loaiduan";
import GiayChungNhan from "layouts/quanlygiayphep/giaychungnhan";
import BackupFile from "layouts/admin/backup";
import Setting from "layouts/setting/setting";
import ActionLog from "layouts/admin/actionlog";
import ExtensionFile from "layouts/danhmuc/extensionFile";
import Share from "layouts/share";

const allRoutes = [
  {
    access: 0,
    type: "collapse",
    name: "Trang chủ",
    key: PermissionMenuKey.home,
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    access: 0,
    type: "collapse",
    name: "Giới thiệu",
    key: PermissionMenuKey.gioiThieu,
    icon: <></>,
    hiding: true,
    route: `/${PermissionMenuKey.gioiThieu}`,
    component: <About />,
  },
  {
    access: 0,
    type: "collapse",
    name: "Tin tức",
    key: PermissionMenuKey.tinTuc,
    icon: <></>,
    hiding: true,
    route: `/${PermissionMenuKey.tinTuc}`,
    component: <News />,
    collapse: [
      {
        access: 0,
        type: "collapse",
        name: "Chi tiết tin tức",
        title: "Chi tiết tin tức",
        key: PermissionMenuKey.chiTietTinTuc,
        icon: <></>,
        route: `/${PermissionMenuKey.tinTuc}/:slug`,
        component: <DetailNews />,
      },
    ],
  },
  {
    access: 0,
    type: "collapse",
    name: "Đăng ký chủ thể",
    key: PermissionMenuKey.dangKyChuThe,
    icon: <></>,
    hiding: true,
    route: `/${PermissionMenuKey.dangKyChuThe}`,
    component: <SignOwner />,
  },
  // {
  //   access: 0,
  //   type: "collapse",
  //   name: "SampleDoc",
  //   key: "doc",
  //   icon: <></>,
  //   hiding: true,
  //   route: `/${"doc"}`,
  //   component: <SampleDoc />,
  // },
  {
    access: 1,
    type: "collapse",
    name: "Thông tin Dashboard",
    key: PermissionMenuKey.dashboard,
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: `/${PermissionMenuKey.dashboard}`,
    component: <Dashboard />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý Hội đồng",
    key: "quanlyhoidong",
    icon: <LocationCityIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Hội đồng",
        title: "Hội đồng",
        key: PermissionMenuKey.hoidong,
        icon: <Diversity2Icon />,
        route: `/quanlyhoidong/${PermissionMenuKey.hoidong}`,
        component: <HoiDong />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Đơn vị",
        title: "Đơn vị",
        key: PermissionMenuKey.donVi,
        icon: <Diversity3Icon />,
        route: `/quanlyhoidong/${PermissionMenuKey.donVi}`,
        component: <DonViHoiDong />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Thành viên",
        title: "Thành viên",
        key: PermissionMenuKey.thanhvien,
        icon: <Person2Icon />,
        route: `/quanlyhoidong/${PermissionMenuKey.thanhvien}`,
        component: <ThanhVien />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Chủ thể OCOP",
    key: PermissionMenuKey.quanlychuthe,
    icon: <PsychologyIcon />,
    route: `/${PermissionMenuKey.quanlychuthe}`,
    component: <ChuTheOCOP />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý Sản phẩm OCOP",
    key: "quanlysanphamocop",
    icon: <DisplaySettingsIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Sản phẩm OCOP",
        title: "Sản phẩm OCOP",
        key: PermissionMenuKey.sanpham,
        icon: <CategoryIcon />,
        route: `/quanlysanphamocop/${PermissionMenuKey.sanpham}`,
        component: <SanPhamOCOP />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Đăng ký Sản phẩm OCOP",
        title: "Đăng ký Sản phẩm OCOP",
        key: PermissionMenuKey.phieudangky,
        icon: <AppRegistrationIcon />,
        route: `/quanlysanphamocop/${PermissionMenuKey.phieudangky}`,
        component: <DangKySanPham />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Hồ sơ đăng ký",
        title: "Hồ sơ đăng ký",
        key: PermissionMenuKey.hoSoDangKy,
        icon: <SnippetFolderIcon />,
        route: `/quanlysanphamocop/${PermissionMenuKey.hoSoDangKy}`,
        component: <HoSoDangKy />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Quản lý Giấy chứng nhận sản phẩm OCOP",
        title: "Quản lý Giấy chứng nhận sản phẩm OCOP",
        key: PermissionMenuKey.quanlyGiayPhep,
        icon: <TaskIcon />,
        route: `/quanlysanphamocop/${PermissionMenuKey.quanlyGiayPhep}`,
        component: <QuanLyGiayPhep />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Giấy chứng nhận (giai đoạn trước QĐ 148/QĐ-TTg hiện hành)",
        title: "Giấy chứng nhận (giai đoạn trước QĐ 148/QĐ-TTg hiện hành)",
        key: PermissionMenuKey.quanlyGiayPhep_1048,
        icon: <TaskIcon />,
        route: `/quanlysanphamocop/${PermissionMenuKey.quanlyGiayPhep_1048}`,
        component: <GiayChungNhan />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Chấm điểm, đánh giá cấp Huyện",
    key: "chamdiemcaphuyen",
    icon: <Flaky />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Hội đồng OCOP cấp Huyện",
        title: "Hội đồng OCOP cấp Huyện",
        key: PermissionMenuKey.chamdiem,
        icon: <TaskAlt />,
        route: `/chamdiemcaphuyen/${PermissionMenuKey.chamdiem}`,
        component: <PhieuChamDiem />,
        collapse: [
          {
            access: 1,
            type: "collapse",
            name: "Chấm điểm Hồ sơ OCOP",
            title: "Chấm điểm Hồ sơ OCOP",
            key: PermissionMenuKey.chamdiemhoso,
            icon: <></>,
            route: `/chamdiemcaphuyen/${PermissionMenuKey.chamdiem}/${PermissionMenuKey.chamdiemhoso}`,
            hiding: true,
            component: <FormChamDiem />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Chi tiết thông tin chấm điểm",
            title: "Chi tiết thông tin chấm điểm",
            key: PermissionMenuKey.chiTietChamDiem,
            icon: <></>,
            route: `/chamdiemcaphuyen/${PermissionMenuKey.chamdiem}/${PermissionMenuKey.chiTietChamDiem}`,
            hiding: true,
            component: <DetailChamDiem />,
          },
        ],
      },
      {
        access: 1,
        type: "collapse",
        name: "Quản lý Hội đồng chấm điểm cấp Huyện",
        title: "Quản lý Hội đồng chấm điểm cấp Huyện",
        key: PermissionMenuKey.moHoidongchamdiem,
        icon: <BeenhereIcon />,
        route: `/chamdiemcaphuyen/${PermissionMenuKey.moHoidongchamdiem}`,
        component: <QuanLyHoiDong />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Chấm điểm, đánh giá cấp Tỉnh",
    key: "chamdiemcaptinh",
    icon: <Flaky />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Hồ sơ đăng ký OCOP cấp tỉnh",
        title: "Hồ sơ đăng ký OCOP cấp tỉnh",
        key: PermissionMenuKey.hosodangkycaptinh,
        icon: <AppRegistrationIcon />,
        route: `/chamdiemcaptinh/${PermissionMenuKey.hosodangkycaptinh}`,
        component: <HoSoDangKySanPham />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Hội đồng OCOP cấp Tỉnh",
        title: "Hội đồng OCOP cấp Tỉnh",
        key: PermissionMenuKey.ocopcaptinh,
        icon: <GroupWorkIcon />,
        route: `/chamdiemcaptinh/${PermissionMenuKey.ocopcaptinh}`,
        component: <HoiDongOCOPCapTinh />,
        collapse: [
          {
            access: 1,
            type: "collapse",
            name: "Chấm điểm Hồ sơ OCOP",
            title: "Chấm điểm Hồ sơ OCOP",
            key: PermissionMenuKey.chamdiemhosocaptinh,
            icon: <></>,
            route: `/chamdiemcaptinh/${PermissionMenuKey.ocopcaptinh}/${PermissionMenuKey.chamdiemhosocaptinh}`,
            hiding: true,
            component: <FormChamDiemCapTinh />,
          },
          {
            access: 1,
            type: "collapse",
            name: "Chi tiết thông tin chấm điểm",
            title: "Chi tiết thông tin chấm điểm",
            key: PermissionMenuKey.chiTietChamDiemCapTinh,
            icon: <></>,
            route: `/chamdiemcaptinh/${PermissionMenuKey.ocopcaptinh}/${PermissionMenuKey.chiTietChamDiemCapTinh}`,
            hiding: true,
            component: <DetailChamDiemCapTinh />,
          },
        ],
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Tin tức",
    key: PermissionMenuKey.quanLyTinTuc,
    icon: <NewspaperIcon />,
    route: `/${PermissionMenuKey.quanLyTinTuc}`,
    component: <TinTuc />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Giới thiệu Website",
    key: PermissionMenuKey.quanLyGioiThieu,
    icon: <NewspaperIcon />,
    route: `/${PermissionMenuKey.quanLyGioiThieu}`,
    component: <GioiThieu />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Báo cáo, thống kê",
    key: "tracuu",
    icon: <CollectionsBookmarkIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Thống kê Chủ thể OCOP",
        title: "Thống kê Chủ thể OCOP",
        key: PermissionMenuKey.thongKeChuthe,
        icon: <AllInboxIcon />,
        route: `/tracuu/${PermissionMenuKey.thongKeChuthe}`,
        component: <ThongKeChuThe />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Thống kê sản phẩm",
        title: "Thống kê sản phẩm",
        key: PermissionMenuKey.thongKeSanPham,
        icon: <AllInboxIcon />,
        route: `/tracuu/${PermissionMenuKey.thongKeSanPham}`,
        component: <ThongKeSanPham />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Tổng hợp sản phẩm OCOP",
        title: "Tổng hợp sản phẩm OCOP",
        key: PermissionMenuKey.tongHopSanPhamOCOP,
        icon: <FunctionsIcon />,
        route: `/tracuu/${PermissionMenuKey.tongHopSanPhamOCOP}`,
        component: <TongHopSanPhamOCOP />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Danh mục",
    key: "danhmuc",
    icon: <ClassIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Đơn vị hành chính",
        title: "Đơn vị hành chính",
        key: PermissionMenuKey.donViHanhChinh,
        icon: <PermDataSettingIcon />,
        route: `/danhmuc/${PermissionMenuKey.donViHanhChinh}`,
        component: <DonVi />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Loại hình tổ chức",
        title: "Loại hình tổ chức",
        key: PermissionMenuKey.loaiHinh,
        icon: <HdrAutoIcon />,
        route: `/danhmuc/${PermissionMenuKey.loaiHinh}`,
        component: <LoaiHinh />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Nhóm ngành",
        title: "Nhóm ngành",
        key: PermissionMenuKey.nhomNganh,
        icon: <Diversity3Icon />,
        route: `/danhmuc/${PermissionMenuKey.nhomNganh}`,
        component: <NhomNganhNghe />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Ngành nghề",
        title: "Ngành nghề",
        key: PermissionMenuKey.nganhNghe,
        icon: <PermDataSettingIcon />,
        route: `/danhmuc/${PermissionMenuKey.nganhNghe}`,
        component: <NganhNghe />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Nhóm sản phẩm",
        title: "Nhóm sản phẩm",
        key: PermissionMenuKey.nhomSanpham,
        icon: <Shop2Icon />,
        route: `/danhmuc/${PermissionMenuKey.nhomSanpham}`,
        component: <NhomSanPham />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Nhóm cha của bộ tiêu chí",
        title: "Nhóm cha của bộ tiêu chí",
        key: PermissionMenuKey.nhomChaBotieuchi,
        icon: <SpeakerGroupIcon />,
        route: `/danhmuc/${PermissionMenuKey.nhomChaBotieuchi}`,
        component: <NhomCha />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Nhóm bộ tiêu chí",
        title: "Nhóm bộ tiêu chí",
        key: PermissionMenuKey.nhomBotieuchi,
        icon: <SpeakerGroupIcon />,
        route: `/danhmuc/${PermissionMenuKey.nhomBotieuchi}`,
        component: <NhomBoTieuChi />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Bộ tiêu chí",
        title: "Bộ tiêu chí",
        key: PermissionMenuKey.boTieuchi,
        icon: <HubIcon />,
        route: `/danhmuc/${PermissionMenuKey.boTieuchi}`,
        component: <BoTieuChi />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Hạng sản phẩm",
        title: "Hạng sản phẩm",
        key: PermissionMenuKey.hang,
        icon: <Star />,
        route: `/danhmuc/${PermissionMenuKey.hang}`,
        component: <Hang />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Loại văn bản",
        title: "Loại văn bản",
        key: PermissionMenuKey.loaiVanban,
        icon: <DescriptionIcon />,
        route: `/danhmuc/${PermissionMenuKey.loaiVanban}`,
        component: <LoaiVanBan />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Quản trị tệp tin",
        key: PermissionMenuKey.extensionFile,
        icon: <Extension />,
        route: `/admin/${PermissionMenuKey.extensionFile}`,
        component: <ExtensionFile />,
      },
    ],
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản lý văn bản",
    key: PermissionMenuKey.quanlyvanban,
    icon: <DescriptionIcon />,
    route: `/${PermissionMenuKey.quanlyvanban}`,
    component: <Vanban />,
  },
  {
    access: 3,
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    component: <SignIn />,
  },
  {
    access: 3,
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">password</Icon>,
    route: "/reset-password",
    component: <Cover />,
  },
  {
    access: 3,
    type: "collapse",
    name: "Confirm Password",
    key: "confirm-password",
    icon: <Icon fontSize="small">password</Icon>,
    route: "/confirmpassword/:uidb64/:token",
    component: <ConfirmPassword />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Thiết lập hệ thống",
    key: PermissionMenuKey.setting,
    icon: <></>,
    hiding: true,
    route: `/${PermissionMenuKey.setting}`,
    component: <Setting />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Tích hợp và chia sẻ dữ liệu",
    key: PermissionMenuKey.share,
    icon: <ShareRounded />,
    route: `/${PermissionMenuKey.share}`,
    component: <Share />,
  },
  {
    access: 1,
    type: "collapse",
    name: "Quản trị hệ thống",
    key: "admin",
    icon: <ManageAccountsIcon />,
    route: null,
    component: null,
    collapse: [
      {
        access: 1,
        type: "collapse",
        name: "Danh sách người dùng",
        key: PermissionMenuKey.users,
        icon: <Icon fontSize="small">people</Icon>,
        route: `/admin/${PermissionMenuKey.users}`,
        component: <Users />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Phê duyệt tài khoản người dùng",
        key: PermissionMenuKey.users2,
        icon: <PersonAddDisabledIcon />,
        route: `/admin/${PermissionMenuKey.users2}`,
        component: <Users2 />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Danh sách quyền",
        key: PermissionMenuKey.roles,
        icon: <AdminPanelSettingsIcon />,
        route: `/admin/${PermissionMenuKey.roles}`,
        component: <Roles />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Danh sách chức năng",
        key: PermissionMenuKey.menu,
        icon: <WidgetsIcon />,
        route: `/admin/${PermissionMenuKey.menu}`,
        component: <Menus />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Danh sách nhóm chức năng",
        key: PermissionMenuKey.groupMenu,
        icon: <MenuIcon />,
        route: `/admin/${PermissionMenuKey.groupMenu}`,
        component: <GroupMenus />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Lịch sử nhật ký hệ thống",
        key: PermissionMenuKey.actionLog,
        icon: <DataSaverOn />,
        route: `/admin/${PermissionMenuKey.actionLog}`,
        component: <ActionLog />,
      },
      {
        access: 1,
        type: "collapse",
        name: "Sao lưu dữ liệu hệ thống",
        key: PermissionMenuKey.backupfile,
        icon: <ImportExport />,
        route: `/admin/${PermissionMenuKey.backupfile}`,
        component: <BackupFile />,
      },
    ],
  },
];
export default allRoutes;
